import { render } from "./app-form-select-scroll.vue?vue&type=template&id=a5d48426"
import script from "./app-form-select-scroll.vue?vue&type=script&lang=js"
export * from "./app-form-select-scroll.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/app-form-select-scroll.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5d48426"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5d48426', __exports__)) {
    console.log('reload')
    api.reload('a5d48426', __exports__)
  }
  
  module.hot.accept("./app-form-select-scroll.vue?vue&type=template&id=a5d48426", () => {
    console.log('re-render')
    api.rerender('a5d48426', render)
  })

}


export default __exports__